/**
 * @deprecated Use ../dictionaries/countries
 */
export * from '../dictionaries/countries';
